import React, { ReactElement } from 'react';
import { RaRecord, ResourceContextValue } from 'react-admin';

interface DialogContextProps {
  isEditing?: boolean;
  isCreating?: boolean;
  record?: any;
  resource: ResourceContextValue;
  createForm?: ReactElement;
  editForm?: ReactElement;
  openCreateDialog: () => void;
  openEditDialog: (record: RaRecord) => void;
  closeDialog: () => void;
  setRecord: (record?: RaRecord) => void;
  label: string;
}

const DialogContext = React.createContext<DialogContextProps>({
  isEditing: false,
  isCreating: false,
  record: {},
  resource: '',
  createForm: <></>,
  editForm: <></>,
  openCreateDialog: () => {},
  openEditDialog: () => {},
  closeDialog: () => {},
  setRecord: () => {},
  label: '',
});

DialogContext.displayName = 'DialogContext';

export default DialogContext;
